export default __webpack_public_path__ + "assets/svg-sprite.5df8704ff6a8b7938c194d6e4a670bfb.svg";